import React, {useState, useRef, useEffect, useCallback} from 'react'
import React, {useState, useRef, useEffect, useCallback} from 'react'
import fuzzySearch from '../common/fuzzySearch'
import SelectSearch from "react-select-search";
import axios from "axios";
import {frequencyMonth,NewFrequencyOptionsAll, frequencyOptionsAll, frequencyOptionsDefault, frequencyWeek} from "../common/data/dataTools";

const SaveReportOscope = props =>{
	const {baseUrl,publicUrl, accountLevel,SetSelectedFrequency,selectedFrequencyName,setFrequencyAmountData,selectedFrequency, SaveReportPopUpClose,saveTestData,allActiveAddressModalOpen,settingDisplayLocality,frequencyText,setFreqencyText,displayClass,setDisplayClass,frequencyAmount,setFrequencyAmount,frequencyAmounts,setFrequencyAmounts,displayFrequencyAmount,setDisplayFrequencyAmount} = props
    const bulkPageFrequencies = accountLevel === 'PRO' ? NewFrequencyOptionsAll : NewFrequencyOptionsAll
    const [frequency,setFreqency] = useState([])
    

	let todaysDate = new Date()
    let dateDayOfMonth = todaysDate.getDate();
    let dateDayOfWeek = todaysDate.getDay() + 1;


    const checkLocality = (e, locality) => {
    	console.log('in checkLocality')
    	setLocality(locality)
    }

    const submitFormClick = (e) =>{
    	e.preventDefault();
    	var data = {
    		'type':'device_emulator',
    		'country':saveTestData.country,
    		'freqency':selectedFrequencyName,
    		'frequencyAmount':frequencyAmount
    	}
    	// console.log(data);
    	// axios.post(baseUrl + 'search-simulator-save-screenshot',data).then(r=>{
    	// 	console.log('response',r);
    	// 	console.log(r.data);
    	// })
    	console.log(data)
  
    }

	return(
		<div className="modal-new-style tools-page" id="saveReport">
            <div className="modal-dialog">
		        <div className="modal-content">
		            <div className="modal-header">
		            	<img src={publicUrl + 'img/mobile-moxie.png'} alt="" height="50"/>
                            <h3 className="modal-title" id="addCountrieslabel">
                                Save Test
                            </h3>
                        <button type="button" className="close" onClick={SaveReportPopUpClose}>
                            <i className="material-icons">clear</i>
                        </button>
		            </div>
		             <form method="post">
				        <div className="modal-body">				          
				            <div className="row">
				                <div className="col-md-12">
				           			<h3>
                							How often would you like to Save and Run this keyword/address combination?
              						</h3>
				                </div>
				                <div className="col-md-12">
				                	<div className="input-section mb-2">
				                {bulkPageFrequencies.map((item,i)=>(
										<div className="input-section mt-2">
		                                    <label className="radio-inline">
		                                        <input type="radio" 
		                                        onChange={(e) => settingDisplayLocality(item.value)}
		                                        name="SaveTest" id={"saveTest_"+item.value} 
		                                        value={item.value} 
                                                checked={item.value == selectedFrequency}

		                                        />
		                                        <span className="keywordLocalityFlex">{item.name}</span>
		                                    </label>
		                                </div>		                              
				                ))}
				                	</div>
				                </div>
				                <div className={"col-md-12 mt-3 " + (displayFrequencyAmount)} id="not_show_in_once_and_daily">
				                	<div className="row"> 
				                		<div className="col-md-5 col-lg-4">
				                			<p>
				                				<strong>
				                					{frequencyText}
				                				</strong>
				                			</p>
				                		</div>
				                		<div className="col-md-5 col-lg-4">
				                			<div className="input-section text-dark">
	                                                <SelectSearch
	                                                    value={frequencyAmount}
	                                                    options={frequencyAmounts}
	                                                    filterOptions={fuzzySearch}
														onChange = {(e)=>setFrequencyAmountData(e)}
	                                                />
	                                        </div>
				                		</div>
				                	</div>
				                </div>
				                
				                <div className={"modal-footer mt-4"}>
				                	<button
			                            onClick={(e) => submitFormClick(e)}
			                            className={"btn btn-primary addKeywordBtn "}>Submit
			                        </button>
			                                                    
				                </div>
				            </div>
				        </div>
				    </form>
		        </div>
		    </div>
		</div>
	)
}
export default SaveReportOscope



